export const AVATAR_ELEMENT_TYPES = {
  BASE: "base",
  BACKROUND: "background",
  EYEWEAR: "eyewear",
  HEADGEAR: "headgear",
  COSTUME: "costume",
  OBJECT: "object",
  EXPRESSION: "expression",
};

export const AVATAR_MODAL_CONTEXT = {
  PRESET: "preset",
  CUSTOMISE: "customise",
};

export const AVATAR_OPTION_SELECTION_NONE = "none";

export const AVATAR_DEFAULT_SVG_FILENAME = {
  STUDENT: "default_student",
  NON_STUDENT: "default_non_student",
};
